(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { useEffect } from 'react';
import styled from 'styled-components';
var StyledSection = styled('section').withConfig({
  displayName: "Section__StyledSection",
  componentId: "sc-1dqq901-0"
})([""]);

var Section = function Section(props) {
  var children = props.children;
  useEffect(function () {
    console.warn('Section is deprecated and will be removed.');
  }, []);
  return React.createElement(StyledSection, null, children);
};

__signature__(Section, "useEffect{}");

var _default = Section;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledSection, "StyledSection", "/home/vsts/work/1/s/src/components/containers/Section.js");
  reactHotLoader.register(Section, "Section", "/home/vsts/work/1/s/src/components/containers/Section.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/containers/Section.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();